import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import Tooltip from "@material-ui/core/Tooltip";

import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Brightness1Icon from "@material-ui/icons/Brightness1";

import DashboardIcon from "../../../../../Assets/Logo/DashboardIcon.svg";
import RoleIcon from "../../../../../Assets/Logo/RoleIcon.svg";
import GradeIcon from "../../../../../Assets/Logo/GradeIcon.svg";
import BookIcon from "../../../../../Assets/Logo/BookIcon.svg";
import ClassIcon from "../../../../../Assets/Logo/ClassIcon.svg";
import StudentIcon from "../../../../../Assets/Logo/StudentIcon.svg";
import EmployeeIcon from "../../../../../Assets/Logo/EmployeeIcon.svg";
import FeeIcon from "../../../../../Assets/Logo/FeeIcon.svg";
import ExaminationIcon from "../../../../../Assets/Logo/ExaminationIcon.svg";
import NoticeIcon from "../../../../../Assets/Logo/NoticeIcon.svg";
import AttendanceIcon from "../../../../../Assets/Logo/AttendanceIcon.svg";
import AssignmentIcon from "../../../../../Assets/Logo/AssignmentIcon.svg";
import TimetableIcon from "../../../../../Assets/Logo/TimetableIcon.svg";
import TransportIcon from "../../../../../Assets/Logo/TransportIcon.svg";
import InventoryIcon from "../../../../../Assets/Logo/InventoryIcon.svg";
import LibraryIcon from "../../../../../Assets/Logo/LibraryIcon.svg";

import { useStyles } from "./MenuDrawer.css";

class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: [
        {
          name: "Dashboard",
          defaultUrl: "/administration/dashboard",
          value: false,
          role: ["Admin", "Accountant", "Librarian"],
          icon: (
            <img
              src={DashboardIcon}
              alt="Dashboard"
              style={{ width: 30, height: 30 }}
            />
          ),
          subMenu: [
            {
              name: "Dashboard",
              url: "/administration/dashboard",
            },
          ],
        },
        {
          name: "User Role",
          defaultUrl: "/administration/user",
          value: false,
          role: ["Admin"],
          icon: (
            <img src={RoleIcon} alt="Role" style={{ width: 30, height: 30 }} />
          ),
          subMenu: [
            {
              name: "View Users",
              url: "/administration/user",
            },
          ],
        },
        {
          name: "Subjects",
          defaultUrl: "/administration/subject",
          value: false,
          role: ["Admin"],
          icon: (
            <img
              src={BookIcon}
              alt="Subjects"
              style={{ width: 30, height: 30 }}
            />
          ),
          subMenu: [
            {
              name: "Manage Subjects",
              url: "/administration/subject",
            },
          ],
        },
        {
          name: "Class",
          defaultUrl: "/administration/class",
          value: false,
          role: ["Admin"],
          icon: (
            <img
              src={ClassIcon}
              alt="Classes"
              style={{ width: 30, height: 30 }}
            />
          ),
          subMenu: [
            {
              name: "Manage Classes",
              url: "/administration/class",
            },
          ],
        },
        {
          name: "Grade",
          defaultUrl: "/administration/grade",
          value: false,
          role: ["Admin"],
          icon: (
            <img
              src={GradeIcon}
              alt="Grade"
              style={{ width: 30, height: 30 }}
            />
          ),
          subMenu: [
            {
              name: "Manage Grades",
              url: "/administration/grade",
            },
          ],
        },
        {
          name: "Student",
          defaultUrl: "/administration/students",
          value: false,
          role: ["Admin"],
          icon: (
            <img
              src={StudentIcon}
              alt="Student"
              style={{ width: 30, height: 30 }}
            />
          ),
          subMenu: [
            {
              name: "View Students",
              url: "/administration/students",
            },
            {
              name: "Promote Students",
              url: "/administration/students-Promote",
            },
          ],
        },

        {
          name: "Staff Info",
          defaultUrl: "/administration/staffs",
          value: false,
          role: ["Admin"],
          icon: (
            <img
              src={EmployeeIcon}
              alt="Staffs"
              style={{ width: 30, height: 30 }}
            />
          ),
          subMenu: [
            {
              name: "View Staffs",
              url: "/administration/staffs",
            },
          ],
        },
        {
          name: "Fees",
          defaultUrl: "/administration/Fees-Manage",
          value: false,
          role: ["Admin", "Accountant"],
          icon: (
            <img src={FeeIcon} alt="Fee" style={{ width: 30, height: 30 }} />
          ),
          subMenu: [
            {
              name: "Add Fee Type",
              url: "/administration/Fees-Type",
            },
            {
              name: "Fee Group",
              url: "/administration/Fees-Group",
            },
            {
              name: "Manage Fee",
              url: "/administration/Fees-Manage",
            },
          ],
        },
        {
          name: "Examination",
          defaultUrl: "/administration/exam",
          value: false,
          role: ["Admin"],
          icon: (
            <img
              src={ExaminationIcon}
              alt="Examination"
              style={{ width: 30, height: 30 }}
            />
          ),
          subMenu: [
            {
              name: "Manage Examination",
              url: "/administration/exam",
            },

            {
              name: "Exam Configration",
              url: "/administration/examconfig",
            },

            {
              name: "Marks Register",
              url: "/administration/Marks-Register",
            },
            {
              name: "Publish Results",
              url: "/administration/Marks-Publish",
            },
          ],
        },
        {
          name: "Notice",
          defaultUrl: "/administration/notices",
          value: false,
          role: ["Admin"],
          icon: (
            <img
              src={NoticeIcon}
              alt="Notices"
              style={{ width: 30, height: 30 }}
            />
          ),
          subMenu: [
            {
              name: "View Notice",
              url: "/administration/notices",
            },
          ],
        },
        {
          name: "Attendance",
          defaultUrl: "/administration/Student-Attendance",
          value: false,
          role: ["Admin"],
          icon: (
            <img
              src={AttendanceIcon}
              alt="Attendance"
              style={{ width: 30, height: 30 }}
            />
          ),
          subMenu: [
            {
              name: "Student Attendance",
              url: "/administration/Student-Attendance",
            },
            {
              name: "Staff Attendance",
              url: "/administration/Staff-Attendance",
            },
          ],
        },
        {
          name: "Academies",
          defaultUrl: "/administration/academics",
          value: false,
          role: ["Admin"],
          icon: (
            <img
              src={AssignmentIcon}
              alt="Academics"
              style={{ width: 30, height: 30 }}
            />
          ),
          subMenu: [
            {
              name: "Syllabus and More",
              url: "/administration/academics",
            },
            {
              name: "Assignments",
              url: "/administration/assignment",
            },
          ],
        },

        {
          name: "TimeTable",
          defaultUrl: "/administration/timetable",
          value: false,
          role: ["Admin"],
          icon: (
            <img
              src={TimetableIcon}
              alt="Timetable"
              style={{ width: 30, height: 30 }}
            />
          ),
          subMenu: [
            {
              name: "Manage Timetable",
              url: "/administration/timetable",
            },
            {
              name: "Overall Timetable",
              url: "/administration/timetable/overall",
            },
            {
              name: "Teacher Timetable",
              url: "/administration/timetable/teacher",
            },
          ],
        },

        {
          name: "Transport",
          defaultUrl: "/administration/vehicle",
          value: false,
          role: ["Admin"],
          icon: (
            <img
              src={TransportIcon}
              alt="Transport"
              style={{ width: 30, height: 30 }}
            />
          ),
          subMenu: [
            {
              name: "Drivers",
              url: "/administration/driver",
            },
            {
              name: "Vechicle",
              url: "/administration/vehicle",
            },
          ],
        },
        {
          name: "Inventory",
          defaultUrl: "/administration/inventory",
          value: false,
          role: ["Admin", "Accountatnt"],
          icon: (
            <img
              src={InventoryIcon}
              alt="Inventory"
              style={{ width: 30, height: 30 }}
            />
          ),
          subMenu: [
            {
              name: "Add Inventory",
              url: "/administration/inventory",
            },
          ],
        },

        {
          name: "Library",
          defaultUrl: "/administration/library",
          value: false,
          role: ["Admin", "Librarian"],
          icon: (
            <img
              src={LibraryIcon}
              alt="Library"
              style={{ width: 30, height: 30 }}
            />
          ),
          subMenu: [
            {
              name: "Manage Library",
              url: "/administration/library",
            },
          ],
        },
      ],
    };
  }

  handleOpen = (name) => {
    const newArray = this.state.menu.map((item) =>
      item.name === name
        ? { ...item, value: !item.value }
        : { ...item, value: false }
    );
    this.setState({
      menu: newArray,
    });
  };

  handler = (children) => {
    return children.map((menu, index) => {
      if (!menu.subMenu) {
        return (
          <div key={index}>
            <ListItem
              button
              style={{ display: "flex", flexDirection: "row", paddingLeft: 30 }}
            >
              <Brightness1Icon className={this.props.classes.iconStyle} />
              <ListItemText>
                <Link to={menu.url} className={this.props.classes.sublist}>
                  <Typography
                    style={{ outline: "none", padding: 5, fontSize: 15 }}
                  >
                    {menu.name}
                  </Typography>
                </Link>
              </ListItemText>
            </ListItem>
          </div>
        );
      } else {
        return (
          <div key={index}>
            {this.props.open === false ? (
              <ListItem
                button
                style={{ display: "flex", flexDirection: "row" }}
                onClick={() => this.props.history.push(menu.defaultUrl)}
              >
                <Tooltip title={menu.name} arrow>
                  {menu.icon}
                </Tooltip>
                {menu.value && this.handleOpen(menu.name)}
              </ListItem>
            ) : (
              <ListItem
                button
                style={{ display: "flex", flexDirection: "row" }}
                onClick={() => this.handleOpen(menu.name)}
              >
                {menu.icon}
                <ListItemText>
                  <Typography
                    style={{ outline: "none", padding: 5, fontSize: 15 }}
                  >
                    {menu.name}
                  </Typography>
                </ListItemText>
                {menu.value ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            )}
            <Collapse in={menu.value} timeout="auto" unmountOnExit>
              {this.handler(menu.subMenu)}
            </Collapse>
          </div>
        );
      }
    });
  };

  render() {
    const { classes, role } = this.props;
    let accountMenu = this.state.menu.filter((data) =>
      data.role.includes("Accountant")
    );
    let libraryMenu = this.state.menu.filter((data) =>
      data.role.includes("Librarian")
    );
    let menu =
      role === "admin"
        ? this.state.menu
        : role === "Accountant"
        ? accountMenu
        : role === "Librarian" && libraryMenu;
    return (
      <div className={classes.root}>
        <List>{this.handler(menu)}</List>
      </div>
    );
  }
}

export default withStyles(useStyles)(withRouter(Menu));
